import { useSelector } from 'react-redux'
import { hexToHSL } from '../libs/hex-hsl'
import { selectBranding } from '../selectors/app'
import { selectPartnerBranding, selectPartnerPermissionValueByScope } from '../selectors/partner'
import { ALLOW, PARTNER_CLAIM_BRANDING } from '../constants/permissions'

export function useBranding() {
  const brandingPermision = useSelector(
    (state) => selectPartnerPermissionValueByScope(state, PARTNER_CLAIM_BRANDING),
  )
  const branding = useSelector(brandingPermision === ALLOW ? selectPartnerBranding : selectBranding)
  const hsl = hexToHSL(branding.color)
  const styles = `
      :root {
          --theme-color: #F3103D;
          --theme-color-h: ${hsl.h};
          --theme-color-s: ${hsl.s}%;
          --theme-color-l: ${hsl.l}%;
          --theme-color-a: 1;
      }
    `
  return [styles]
}
